var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolidStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6595 5.65396L15.0789 3.13093C14.9377 2.90444 14.6868 2.76562 14.4189 2.76562H4.58011C4.31222 2.76562 4.06138 2.90444 3.92012 3.13093L2.33958 5.65396C1.52373 6.95687 2.24704 8.76878 3.77157 8.97578C3.88116 8.99039 3.99319 8.9977 4.10521 8.9977C4.82608 8.9977 5.46414 8.6811 5.9025 8.1916C6.34087 8.6811 6.98137 8.9977 7.6998 8.9977C8.42066 8.9977 9.05872 8.6811 9.49709 8.1916C9.93545 8.6811 10.576 8.9977 11.2944 8.9977C12.0152 8.9977 12.6533 8.6811 13.0917 8.1916C13.5325 8.6811 14.1705 8.9977 14.889 8.9977C15.0034 8.9977 15.113 8.99039 15.2226 8.97578C16.752 8.77121 17.4777 6.95931 16.6595 5.65396ZM14.8938 9.77945C14.6503 9.77945 14.4092 9.74292 14.1754 9.68691V12.1174H4.82364V9.68691C4.58985 9.74048 4.34875 9.77945 4.10521 9.77945C3.95909 9.77945 3.81053 9.76971 3.66685 9.75022C3.53047 9.73074 3.39652 9.69908 3.26745 9.66255V14.4553C3.26745 14.8864 3.61571 15.2346 4.04676 15.2346H14.9572C15.3882 15.2346 15.7365 14.8864 15.7365 14.4553V9.66255C15.605 9.70152 15.4735 9.73318 15.3371 9.75022C15.1885 9.76971 15.0424 9.77945 14.8938 9.77945Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolidStore);
export default __webpack_public_path__ + "static/media/icon-solid-store.e951b73e5ec404ea62cc8567820a9211.svg";
export { ForwardRef as ReactComponent };